import { FieldSettings } from '@ana/shared'
import { object } from 'yup'

const buildValidationSchema = <T extends string>(fields: Record<T, FieldSettings>) => {
  return object().shape(
    Object.fromEntries(
      Object.values<FieldSettings>(fields)
        .map((settings) => [settings.name, settings.validation])
        .filter(([_, validation]) => Boolean(validation))
    )
  )
}

export default buildValidationSchema
